const SEP = ' · ';

export function mergeObservacionParts(
  auto: string | null | undefined,
  manual: string | null | undefined
): string | null {
  const parts = [auto, manual]
    .map((s) => String(s ?? '').trim())
    .filter(Boolean);
  return parts.length ? parts.join(SEP) : null;
}

interface PayloadObservacionMeta {
  observacionAuto?: string | null;
  observacionManual?: string | null;
}

export function resolveObservacionAutoFromItem(item: {
  observacion?: string | null;
  meta?: unknown;
  disponibilidad?: { balanceTotalKg?: number; availableKg?: number } | null;
}): string | null {
  const meta =
    item.meta && typeof item.meta === 'object' && !Array.isArray(item.meta)
      ? (item.meta as PayloadObservacionMeta)
      : {};
  if (meta.observacionAuto) return String(meta.observacionAuto).trim() || null;

  const disp = item.disponibilidad;
  if (disp?.balanceTotalKg != null && disp?.availableKg != null) {
    const saldoNegativo = disp.balanceTotalKg - disp.availableKg;
    if (saldoNegativo < 0) {
      return (
        'Saldo negativo: ' +
        new Intl.NumberFormat('es-AR', { maximumFractionDigits: 0 }).format(saldoNegativo) +
        ' kg'
      );
    }
  }

  const obs = String(item.observacion ?? '').trim();
  if (obs.startsWith('Saldo negativo:')) {
    const idx = obs.indexOf(SEP);
    return idx > -1 ? obs.slice(0, idx) : obs;
  }
  return null;
}

export function resolveObservacionManualFromItem(item: {
  observacion?: string | null;
  meta?: unknown;
}): string | null {
  const meta =
    item.meta && typeof item.meta === 'object' && !Array.isArray(item.meta)
      ? (item.meta as PayloadObservacionMeta)
      : {};
  if (meta.observacionManual != null) {
    const manual = String(meta.observacionManual).trim();
    return manual || null;
  }

  const auto = resolveObservacionAutoFromItem(item);
  const obs = String(item.observacion ?? '').trim();
  if (!obs) return null;
  if (auto && obs.startsWith(auto)) {
    const rest = obs.slice(auto.length).replace(new RegExp('^' + SEP), '').trim();
    return rest || null;
  }
  if (!auto) return obs;
  return null;
}

export function canEditObservacion(estado: string | null | undefined): boolean {
  const e = String(estado || '').trim();
  return e === 'Pendiente' || e === 'En proceso' || e === 'Aprobada';
}
